"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ReactPlaceholder_1 = require("./ReactPlaceholder");
exports.default = ReactPlaceholder_1.default;
